import { z } from "zod";

const totals = z.object({ roleDomainFit: z.number().finite(), skillOverlap: z.number().finite() });

export const coachPlanSchema = z.object({
  version: z.literal(1),
  contextKey: z.string(),
  contentKey: z.string(),
  plan: z.object({
    suggestions: z.array(
      z.object({
        id: z.string(),
        sectionId: z.string(),
        sectionName: z.string(),
        itemLabel: z.string(),
        fieldPath: z.string(),
        previousText: z.string(),
        suggestedText: z.string(),
      }),
    ),
    gains: z.record(
      z.object({ targets: z.literal("skillOverlap"), gain: z.number().finite().min(0).max(100) }),
    ),
    skillAdditions: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        description: z.string(),
        evidence: z.string(),
        confidence: z.enum(["evidenced", "unverified"]),
        targets: z.literal("skillOverlap"),
        gain: z.number().finite().min(0).max(100),
      }),
    ),
    originalValues: z.record(z.string()),
    assessed: totals,
    jobRequires: z.array(z.string()),
  }),
});

export type SavedCoachPlan = z.infer<typeof coachPlanSchema>;
